import { getCurrentInstance } from 'vue'
// import { useRoute } from 'vue-router/composables'
import { compileData } from '../utils/index'

export function useTemplate() {
  const { proxy } = getCurrentInstance()
  // const route = useRoute()
  //解决使用keepAlive缓存时路由变化会导致在render函数中使用getTemplateData会触发render函数重新执行
  const initTemplate = {
    currentRouter: proxy.$store?.state.menuStore?.currentRouter || {},
    routeQuery: proxy.$route?.query,
  }
  return {
    getTemplateData(data, extendData) {
      return {
        currentToken: proxy.$store?.state.user.currentToken,
        organization: proxy.$store?.state.user.organization,
        currentTicket: proxy.$store?.state.user.CurrentTicket,
        system: proxy.$store?.state.user.system,
        strategy: proxy.$store?.state.strategy?.strategy ?? {},
        GLOBAL: proxy.GLOBAL,
        ...initTemplate,
        data: data,
        ...extendData,
      }
    },
    compileData,
  }
}
